<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>
        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important; '">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;':'float:left;width:100%;'">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture v-if="this.pagedata"><img
                                              :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                              alt=""
                                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>

                                </picture>


                               <!--            <video style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"-->
<!--                   v-if="this.pagedata && this.pagedata.id==51"  width="100%"-->
<!--                   height="100%" autoplay loop>-->
<!--                <source :src="this.serverurl+'/public/pagebanners/scalping.webm'" type="video/webm" style="position:absolute;top:0;left:0;opacity:1;min-width:100%;min-height:100%;object-fit:cover;object-position:center" />-->
<!--                Your browser does not support the video tag.-->
<!--            </video>-->

                            </div>
                        </figure>
                        <div class="spotlight__info" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata" :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">
                                        {{
$i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle :$i18n.locale=='Русский'?pagedata.page_rutitle: pagedata.page_frtitle
                                        }}</h2>
                                        <br />

<h3 v-if="pagedata" :style="$i18n.locale == 'العربية' ?'text-align: right;font-size: 23px!important;color:#ffffff;font-family: Cairo,sans-serif !important;margin-right:2%;':'font-size: 23px!important;color:#ffffff;font-family: Comfortaa!important;margin-left:2%'">
                                        {{
                                            $i18n.locale == 'en' ? pagedata.en_subtitle : $i18n.locale == 'العربية' ? pagedata.ar_subtitle : $i18n.locale == '中文' ? pagedata.ch_subtitle :$i18n.locale=='Русский'?pagedata.ru_subtitle: pagedata.fr_subtitle
                                        }}</h3>
                                </div>
                            </div>
                                                       <div class="btn_wrap" :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/demoaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                        {{
                                         $i18n.locale == 'en' ? 'Open Demo Account' : $i18n.locale == 'العربية' ? 'فتح حساب تجريبي' : $i18n.locale == '中文' ? '开设模拟账户':$i18n.locale=='Русский'?'Открыть демо-аккаунт' : 'Ouvrir un compte Dé'

                                        }}

                                        </span></a></div>
                                </div>
                                 <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/liveaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                            {{
                                            $i18n.locale == 'en' ? 'Open Live Account' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي' : $i18n.locale == '中文' ? '开设真实账户':$i18n.locale=='Русский'?'Открыть реальный аккаунт': 'Ouvrir un compte Réel'
                                }}
                                        </span></a></div>
                                </div>
                                <div v-if="pagedata.layout==4" class="react-reveal"
                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 360ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg"><a class="no-border"
                                                                                      href="https://www.linkedin.com/company/market-equity-inc/?originalSubdomain=in"
                                                                                      target="_blank"
                                                                                      rel="noopener noreferrer">
                                        <div class=" gatsby-image-wrapper"
                                             style="position: relative; overflow: hidden; display: inline-block; width: 100px; height: 30px;">
                                            <picture><img loading="lazy" width="100" height="30"
                                                          src="https://dev.marketequityinc.com/public/public/follow-linkedin.jpg"
                                                          alt="Follow us on Linked In"
                                                          style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                            </picture>
                                        </div>
                                    </a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section class="FrameWork__InnerPageStyled-v8gq48-0 fHTiUO">
                <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO">
                    <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                        <div aria-hidden="true" style="width:100%;padding-bottom:35.625%"></div>
                        <img aria-hidden="true"
                             src="data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAwT/2gAMAwEAAhADEAAAAZRXKB//xAAUEAEAAAAAAAAAAAAAAAAAAAAQ/9oACAEBAAEFAn//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAQ/9oACAEBAAY/An//xAAXEAADAQAAAAAAAAAAAAAAAAAAARAR/9oACAEBAAE/IdHP/9oADAMBAAIAAwAAABAEH//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABgQAAMBAQAAAAAAAAAAAAAAAAABEVEh/9oACAEBAAE/EKT7IarQnFp//9k="
                             alt=""
                             style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                        <noscript>
                            <picture>


                                <img loading="lazy" sizes="(max-width: 1280px) 100vw, 1280px"
                                     :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner" alt=""
                                     style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>

                            </picture>
                        </noscript>
                    </div>
                </figure>
            </section>
            <section>

                <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo">

                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                        <div class="react-reveal"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">


                            <div class="FrameWork__ContentData-v8gq48-10 ZBsdR" :style="$i18n.locale == 'العربية' ?'text-align: right':'text-align: left'">
                                <div class="FrameWork__Row-v8gq48-2 VIUMD">
                                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn" style="padding-left:10%;padding-right:10%">
                                        <div class="container">
                                            <div class="row align-items-start">

                                                <div align="center"  class="col">
                                                    <picture><img width="250" height="250" v-if="this.profiledata"
                                                                  :src="this.serverurl+'/public/trainers/'+profiledata.photo"
                                                                  alt=""
                                                                  />
                                                    </picture>
                                                    <div style="padding-top:2%"><h2 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family:Roboto,sans-serif;'">{{ profiledata.namear }}</h2></div>

 <div id="profiledata"  v-html="profiledata.descriptionar" :style="$i18n.locale == 'العربية' ? 'direction:rtl;font-family: Cairo, sans-serif !important;text-align:justify;padding-top:2%;padding-left:2%;padding-right:2%' :'font-family:Roboto,sans-serif;text-align:justify;padding-top:2%;padding-left:2%;padding-right:2%'"><h3 :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family:Roboto,sans-serif;'">{{ profiledata.descriptionar }}</h3></div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>


            </section>





            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'profile',
    data() {
        return {
            pagedata: '',
            profiledata:''
        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
        var pathvalues = (this.$route.path).split("/");


        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }


        this.loadpagedata('profile');
        this.loadprofiledata(pathvalues[4]);

    },

    methods: {
        loadprofiledata(profileid) {

            this.$axios.get("loadprofiledata", {
                params: {
                    profileid: profileid
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)

                        this.profiledata = res.data.profiledata[0];



                    }
                });


        },
        loadpagedata(pagename) {

            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.pagedata = res.data.pagedata[0];
                                          }
                });


        },
    }
}
</script>

<style>
th {
    background-color: #005060;
    color: #ffffff;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.carousel {
    background: #2f4357;
    margin-top: 20px;
}

.carousel-item {
    text-align: center;
    min-height: 280px; /* Prevent carousel from being distorted if for some reason image doesn't load */
}

.rtlclass {
    direction: rtl !important;


}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}

#tabela th, td {
    padding: 30px;
}

tabela tr:nth-child(even) {
    background-color: #f2f2f2;
}

a:hover, a:focus {
    text-decoration: none;
    outline: none;
}

#accordion .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 15px;
}

#accordion .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordion .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 1px 1px 1px #fff;
    position: relative;

}

#accordion .panel-title a:before {
    content: "-";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: #929191;
    font-size: 12px;
    font-weight: 900;
    color: #fdfbfb;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;
}

#accordion .panel-title a.collapsed:before {
    content: "+";
}

#accordion .panel-body {
    padding: 10px 15px;
    font-size: 15px;
    color: #222;
    line-height: 27px;
    border: none;
}

#accordion .panel-body p {
    margin-bottom: 0;
}
#profiledata ul li{
    list-style: square !important;
}

</style>

